module.exports = __webpack_public_path__ + "static/media/Shotgrid.b635b68a.png";